//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

export enum TAGGING_FEED_ACTION_TYPES {
  REQUEST_FEED = 'TAGGING_FEED/REQUEST_FEED',
  RECEIVE_FEED_SUCCEEDED = 'TAGGING_FEED/RECEIVE_FEED_SUCCEEDED',
  RECEIVE_FEED_FAILED = 'TAGGING_FEED/RECEIVE_FEED_FAILED',
  REQUEST_FEED_COUNTS = 'TAGGING_FEED/REQUEST_FEED_COUNTS',
  RECEIVE_FEED_COUNTS_SUCCEEDED = 'TAGGING_FEED/RECEIVE_FEED_COUNTS_SUCCEEDED',
  RECEIVE_FEED_COUNTS_FAILED = 'TAGGING_FEED/RECEIVE_FEED_COUNTS_FAILED',
  SET_GRID_LAYOUT_VALUE = 'TAGGING_FEED/SET_GRID_LAYOUT_VALUE',
  OPEN_PUBLISH_ALL_MODAL = 'TAGGING_FEED/OPEN_PUBLISH_ALL_MODAL',
  CLOSE_PUBLISH_ALL_MODAL = 'TAGGING_FEED/CLOSE_PUBLISH_ALL_MODAL',
  OPEN_ITEM_DETAILS_MODAL = 'TAGGING_FEED/OPEN_ITEM_DETAILS_MODAL',
  CLOSE_ITEM_DETAILS_MODAL = 'TAGGING_FEED/CLOSE_ITEM_DETAILS_MODAL',
  UPDATE_PAGE_NUMBER = 'TAGGING_FEED/UPDATE_PAGE_NUMBER',
  PUBLISH_ALL_ITEMS = 'TAGGING_FEED/PUBLISH_ALL_ITEMS',
  PUBLISH_ALL_ITEMS_SUCCEEDED = 'TAGGING_FEED/PUBLISH_ALL_ITEMS_SUCCEEDED',
  PUBLISH_ALL_ITEMS_FAILED = 'TAGGING_FEED/PUBLISH_ALL_ITEMS_FAILED',
  PUBLISH_ITEMS = 'TAGGING_FEED/PUBLISH_ITEMS',
  PUBLISH_ITEMS_SUCCEEDED = 'TAGGING_FEED/PUBLISH_ITEMS_SUCCEEDED',
  PUBLISH_ITEMS_FAILED = 'TAGGING_FEED/PUBLISH_ITEMS_FAILED',
  REMOVE_ITEMS = 'TAGGING_FEED/REMOVE_ITEMS',
  REMOVE_ITEMS_SUCCEEDED = 'TAGGING_FEED/REMOVE_ITEMS_SUCCEEDED',
  REMOVE_ITEMS_FAILED = 'TAGGING_FEED/REMOVE_ITEMS_FAILED',
  FORCE_UPDATE_ITEMS = 'TAGGING_FEED/FORCE_UPDATE_ITEMS',
  FORCE_UPDATE_ITEMS_FINISHED = 'TAGGING_FEED/FORCE_UPDATE_ITEMS_FINISHED',
  SET_FEED_GENERATION_STATE = 'TAGGING_FEED/SET_FEED_GENERATION_STATE',
  SET_FEED_GENERATION_LOOKUP_STATUS = 'TAGGING_FEED/SET_FEED_GENERATION_LOOKUP_STATUS',
  SET_ITEM_DETAILS_MODAL_SELECTED_ITEM = 'TAGGING_FEED/SET_ITEM_DETAILS_MODAL_SELECTED_ITEM',
  SET_PRODUCT_ERROR_FILTER_VALUE = 'TAGGING_FEED/SET_PRODUCT_ERROR_FILTER_VALUE',
  SET_SEARCH_TEXT_VALUE = 'TAGGING_FEED/SET_SEARCH_TEXT_VALUE',
}

export enum TAGGING_SETTINGS_ACTION_TYPES {
  REQUEST_SETTINGS = 'TAGGING_SETTINGS/REQUEST_SETTINGS',
  RECEIVE_SETTINGS_SUCCEEDED = 'TAGGING_SETTINGS/RECEIVE_SETTINGS_SUCCEEDED',
  RECEIVE_SETTINGS_FAILED = 'TAGGING_SETTINGS/RECEIVE_SETTINGS_FAILED',
  REQUEST_DYNAMIC_LANDING_PAGE_SITE_NAME = 'TAGGING_SETTINGS/REQUEST_DYNAMIC_LANDING_PAGE_SITE_NAME',
  RECEIVE_DYNAMIC_LANDING_PAGE_SITE_NAME_SUCCEEDED = 'TAGGING_SETTINGS/RECEIVE_DYNAMIC_LANDING_PAGE_SITE_NAME_SUCCEEDED',
  RECEIVE_DYNAMIC_LANDING_PAGE_SITE_NAME_FAILED = 'TAGGING_SETTINGS/RECEIVE_DYNAMIC_LANDING_PAGE_SITE_NAME_FAILED',
  OPEN_SETTINGS_MODAL = 'TAGGING_SETTINGS/OPEN_SETTINGS_MODAL',
  CLOSE_SETTINGS_MODAL = 'TAGGING_SETTINGS/CLOSE_SETTINGS_MODAL',
  UPDATE_HEADLINE = 'TAGGING_SETTINGS/UPDATE_HEADLINE',
  UPDATE_LANDING_PAGE_TYPE = 'TAGGING_SETTINGS/UPDATE_LANDING_PAGE_TYPE',
  UPDATE_DYNAMIC_LANDING_PAGE_URL = 'TAGGING_SETTINGS/UPDATE_DYNAMIC_LANDING_PAGE_URL',
  UPDATE_STATIC_LANDING_PAGE_URL = 'TAGGING_SETTINGS/UPDATE_STATIC_LANDING_PAGE_URL',
  SAVE_SETTINGS = 'TAGGING_SETTINGS/SAVE_SETTINGS',
  SAVE_SETTINGS_SUCCEEDED = 'TAGGING_SETTINGS/SAVE_SETTINGS_SUCCEEDED',
  SAVE_SETTINGS_FAILED = 'TAGGING_SETTINGS/SAVE_SETTINGS_FAILED',
}

export const NUM_ITEMS_PER_PAGE = 24;
export const HEADLINE_MAX_LENGTH = 100;
export const DYNAMIC_LANDING_PAGE_URL_MAX_LENGTH = 300;
export const STATIC_LANDING_PAGE_URL_MAX_LENGTH = 500;
export const DYNAMIC_LANDING_PAGE_READABLE_NAME = 'Bazaarvoice ONE Page';
export const STATIC_LANDING_PAGE_READABLE_NAME = 'Static Landing Page';

// Our APIs cannot guarantee pagination past 10,000 items, so
// we'll set a cap on the number of pages we expose to the
// user based on this cap. To be safe, we'll cap the value
// at 9,500.
export const MAX_NUMBER_OF_ITEMS_ACROSS_ALL_PAGES = 9500;

export const PRODUCT_ERROR_STRINGS = {
  SUMMARY: {
    ALL: 'All tagged products have errors. As a result this item will not be published',
    MULTIPLE:
      'One or more products have errors and may not be visible in your ad',
    SINGLE: 'This product has errors and may not appear in your ad',
  },
  INDIVIDUAL: {
    CRAWLED: 'Product is not linked to catalog',
    UNAVAILABLE: 'Product is out of stock',
    EXPIRED: 'Product was removed from catalog',
    SPATIALTAGS: 'Product has no spatial tag',
  },
};

export enum PRODUCT_ERROR_FILTER_VALUE {
  ALL = 'all',
  NO_SPATIAL_TAG = 'noSpatialTag',
  CRAWLED = 'crawled',
  EXPIRED = 'expired',
  UNAVAILABLE = 'unavailable',
}

export const PRODUCT_ERROR_FILTER_LABELS = {
  [PRODUCT_ERROR_FILTER_VALUE.ALL]: 'All',
  [PRODUCT_ERROR_FILTER_VALUE.NO_SPATIAL_TAG]:
    PRODUCT_ERROR_STRINGS.INDIVIDUAL.SPATIALTAGS,
  [PRODUCT_ERROR_FILTER_VALUE.CRAWLED]:
    PRODUCT_ERROR_STRINGS.INDIVIDUAL.CRAWLED,
  [PRODUCT_ERROR_FILTER_VALUE.EXPIRED]:
    PRODUCT_ERROR_STRINGS.INDIVIDUAL.EXPIRED,
  [PRODUCT_ERROR_FILTER_VALUE.UNAVAILABLE]:
    PRODUCT_ERROR_STRINGS.INDIVIDUAL.UNAVAILABLE,
};

export const ASSET_FEEDS_MANAGE_PERMISSION = 'asset_feeds:manage';
